import { formatCurrency } from '@ps/web-poker-utils';

import i18n from '../../i18n';
import type { Language } from '../../types';
import { AttributeKey } from '../types';

export default function pppAttributes(
  {
    buyIn,
    rake,
    currency,
    isPlayMoney,
    scalePM,
    maxPlayersPerTable,
    winUpTo
  }: {
    buyIn: number;
    rake: number;
    currency: string;
    isPlayMoney?: number;
    scalePM?: number;
    maxPlayersPerTable: number;
    winUpTo: number;
  },
  language: Language
) {
  const i18nInstance = i18n(language);

  const attributes = [
    {
      name: i18nInstance('TXTWBCLI_Buy_In'),
      value: buyIn
        ? formatCurrency(buyIn + rake, currency, {
            separators: true,
            isPlayMoney,
            scalePM
          })
        : i18nInstance('TXTWBCLI_Freeroll'),
      key: AttributeKey.buyIn
    }
  ];

  attributes.push({
    name: i18nInstance('TXTWBCLI_Players'),
    value: `${maxPlayersPerTable}`,
    key: AttributeKey.players
  });

  attributes.push({
    name: i18nInstance('TXTWBCLI_Win_Up_To'),
    value: formatCurrency(winUpTo, currency, {
      separators: true,
      shorten: true,
      isPlayMoney,
      scalePM
    }),
    key: AttributeKey.winUpTo
  });

  return attributes;
}
